<button class="mm-feedback-content-main-topic-button" (click)="topicClicked.emit()">
    {{topicTitle}}
</button>
